<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">签名</span>
            <span class="save" @click="save">保存</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <textarea class="sign" v-model="signContent" maxlength="16" placeholder="请输入个性签名（字数限制16字）" cols="30" rows="10"></textarea>
            </div>
        </div>
    </div>
</template>
<script>
import { updateUserAction } from '../../assets/js/api'
import { Toast } from 'mint-ui'
import { setUserInfoLocalStorage } from '../../assets/js/localStorage'
import { showUserAction } from '../../assets/js/api'

export default {
  data() {
    return {  
        signContent: this.$route.query.signContent,
        originContent: this.$route.query.signContent,
        userInfo: {},
    };
  },
  computed: {},
  components: {},
  methods: {
      //获取个人信息
      getUserInfo(){
          showUserAction().then (res => {
              if (res.s == 0) {
                if (res.user) {
                    var user = res.user
                    this.userInfo.sex = user.sex ? user.sex : 0
                    this.userInfo.avatar = user.avatar ? user.avatar : ''
                    this.userInfo.nick = user.nick ? user.nick : ''
                    this.userInfo.address = user.address ? user.address : ''
                    this.userInfo.info = user.info ? user.info : ''
                    this.userInfo.birthday = user.birthday ? user.birthday : ''
                    this.userInfo.identity = user.identity ? user.identity : ''

                    setUserInfoLocalStorage(JSON.stringify(this.userInfo))
                    this.$router.back()
                }
              }
          })
      },
      //提交签名
      save(){
          if (this.signContent == this.originContent) {
            this.getUserInfo()
            return
          }
          updateUserAction(-1, null, null, null, this.signContent, null, null)
          .then(res => {
            if (res.s == 0) {
                this.getUserInfo()
                Toast:Toast({
                    message: '保存成功',
                    position: 'middle',
                    duration: 2500
                })
            }
          })
          .catch(err => {
            Toast:Toast({
            message: '网络不给力，请稍后重试',
            position: 'middle',
            duration: 2500
          })
        })
    }
  }
}
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translateY(-50%);
}
.save {
  font-size: 0.42rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 88%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
    width: 100%;
    height: auto;
    margin-top: 0.39rem;
}
.sign{
    width: 9.19rem;
    height: 3.75rem;
    padding-top: 0.2rem;
    padding-left: 0.2rem;
    border: 0.03rem solid rgba(187, 187, 187, 1);
    margin-left: 0.26rem;
    font-size: 0.42rem;
    line-height: 0.53rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/sign.vue